import { useEffect, useState, type RefObject } from 'react'
import ReactDOM from 'react-dom'

export const OverlayLogo = ({
  targetRef,
  onClick,
  logo,
}: {
  targetRef: RefObject<HTMLImageElement | null>
  onClick: () => void
  logo: string
}) => {
  const [pos, setPos] = useState<{
    top: number
    left: number
    width: number
    height: number
  } | null>(null)

  useEffect(() => {
    if (targetRef.current) {
      const rect = targetRef.current.getBoundingClientRect()
      setPos({
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
      })
    }
  }, [targetRef])

  if (!pos) return null

  return ReactDOM.createPortal(
    <img
      src={logo}
      width={118}
      height={44}
      onClick={onClick}
      style={{
        position: 'fixed',
        top: pos.top,
        left: pos.left,
        width: pos.width,
        height: pos.height,
        zIndex: 50, // definitely above canvas
      }}
    />,
    document.body
  )
}
